// extracted by mini-css-extract-plugin
export default {"container":"Card_container__1vvp3","capa":"Card_capa__L8aIy","favoritar":"Card_favoritar__FGAxl","link":"Card_link__iC6jq"};